module.exports = __webpack_public_path__ + "static/media/what-words-to-steal.ba2a75cf.txt";